<div class="fastival_background">
    <div class="tree_image"></div>
    <div class="santa_img"></div>
    <canvas #emojiSnow></canvas>
</div>